import {PricingNoteDTO} from "./dto/PricingDTO";

export class PricingNote
{
    private readonly _type: string
    private readonly _text: string

    constructor(note: PricingNoteDTO) {
        if(note) {
            this._type = note.type;
            this._text = note.text
        }
    }

    get type(): string {
        return this._type;
    }

    get text(): string {
        return this._text;
    }
}
